import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import { ApplicationConfiguration } from '../../../models/app_config_model';

export class TosController {
  private institutionPrivacyURL: string;

  constructor(
    private acceptTOUCommand: ICommand,
    private declineTOUCommand: ICommand,
    private accountModel: AccountModel,
    private appConfigModel: ApplicationConfiguration
  ) {
    this.institutionPrivacyURL = this.appConfigModel.getConfigProperty('core-privacy_policy_url');
  }

  declineTerms() {
    this.declineTOUCommand();
  }

  acceptTerms() {
    this.acceptTOUCommand();
  }
}

export class TOSComponent implements angular.IComponentOptions {
  public templateUrl: string = 'lib/tos/components/tos/tos.html';
  public controller: any = TosController;
}



// WEBPACK FOOTER //
// ./app/lib/tos/components/tos/tos.ts